import Image from "next/image";
import styles from "./FilterTag.module.scss";
import assetLoader from "@utils/internalImageLoder";

interface FilterTagProps {
  label: string;
  prefix?: string;
  onClick?: () => void;
}

export default function FilterTag({ label, prefix, onClick }: FilterTagProps) {
  return (
    <div className={styles.filterTag} onClick={onClick}>
      {prefix && <span className={styles.prefix}>{prefix}</span>}
      <span className={styles.label}>{label}</span>
      <Image
        loading="lazy"
        src={`${assetLoader()}/icons/Chevron_down_dark.svg`}
        alt={`${label} dropdown icon`}
        width={30}
        height={30}
        className={styles.icon}
      />
    </div>
  );
}
